window.updateHeaderCTA = function () {
    if (typeof window.ProjectStore === 'undefined') {
        return; // Store not loaded
    }

    const headerCTAs = Array.from(document.querySelectorAll('[data-pf-cta="project"]'));
    const menuCta = document.getElementById('HeaderMenu-start-now');
    if (menuCta) headerCTAs.push(menuCta);

    if (headerCTAs.length === 0) return;

    const incomplete = window.ProjectStore.getIncomplete();

    let label = "Start your Portrait";
    let href = "/pages/portrait-types";

    if (incomplete.length === 1) {
        label = "Continue Your Painting";
        href = `/products/${incomplete[0].product_handle}?resume=1&project_id=${incomplete[0].project_id}`;
    } else if (incomplete.length >= 2) {
        label = "My Projects";
        href = "/pages/my-masterpieces";
    }

    headerCTAs.forEach(cta => {
        // Handle spans inside menus specifically
        const innerSpan = cta.querySelector('.header__active-menu-item') || cta.querySelector('span');
        if (innerSpan) {
            innerSpan.textContent = label;
        } else {
            cta.textContent = label;
        }

        cta.setAttribute('aria-label', label);
        if (cta.tagName === 'A') {
            cta.href = href;
        } else {
            cta.onclick = () => { window.location.href = href; };
        }
    });
};

document.addEventListener('DOMContentLoaded', window.updateHeaderCTA);
